import React from 'react';
import { websiteUrl } from '../../const/constants';
import defaultExhibitionImage from "../../Assets/images/default-exhibition.jpg"; 
export default function ExhibitionsCarousel({ exhibitions, selectedExhibition, handleExhibitionSelect }) {
   const getImageUrl = (imagePath) => {
    if (!imagePath) return defaultExhibitionImage;
    if (imagePath.startsWith("http")) return imagePath;
    return `${websiteUrl}/exhibitionImages/${imagePath.replace(/^\//, "")}`;
  }; 
  return (
    <div className="flex overflow-x-auto gap-4">
      {exhibitions.map((exh) => (
        <div
          key={exh.id}
          onClick={() => handleExhibitionSelect(exh)}
          className={`cursor-pointer p-4 rounded-lg ${selectedExhibition?.id === exh.id ? 'bg-primary text-white' : 'bg-gray-200'}`}
        >
          <img src={getImageUrl(exh?.image)} alt={exh.year} className="h-32" />
          <p>{exh.saal || exh.year}</p>
        </div>
      ))}
    </div>
  );
}